import { GradientType, PageBackgroundData } from 'types/pageTypes';

/**
 * Generate the background string given the page background data
 *
 * @param bg Page background
 * @returns CSS background string
 */
const generateBackgroundString = ({ background, gradientBackground, backgroundPattern }: PageBackgroundData) => {
  // No gradient, return the background color
  if (!gradientBackground && background) {
    return `${backgroundPattern ? backgroundPattern.svgPattern + ', ' : ''}${background}`;
  }

  // Default to white if no solid colour or gradient - should not reach here
  if (!background && (!gradientBackground || gradientBackground?.colors.length === 0)) {
    return '#FFFFFF';
  }

  let bgString = '#FFFFFF';
  const { type, colors, angle = 180, circleAtCenter = '' } = gradientBackground!;
  switch (type) {
    case GradientType.LinearGradient: {
      bgString = `linear-gradient(${angle}deg, ${colors.join(', ')})`;
      break;
    }
    case GradientType.RadialGradient: {
      bgString = `radial-gradient(${circleAtCenter ? circleAtCenter + ',' : ''}${colors.join(', ')})`;
      break;
    }
    default: {
      break;
    }
  }

  return `${backgroundPattern ? backgroundPattern.svgPattern + ', ' : ''}${bgString}`;
};

export { generateBackgroundString };
